import * as React from 'react'
import { ReactNode } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

import { Box, Icon, colors } from '@factorialco/deprecated-design-system'
import markerPointer from 'assets/images/marker-pointer.svg'

import * as styles from './index.vanilla.css'

export interface CustomMarker {
  position: { lat: number; lng: number }
  radius: number
  avatar?: ReactNode
  label: string
  isIncident?: boolean
}

interface Props {
  avatar?: ReactNode
  label: string
  isIncident?: boolean
}

const CustomMarkerDiv = ({ avatar, label, isIncident = false }: Props) => {
  const alertIcon = (
    <Box
      style={{ backgroundColor: colors.champagne200 }}
      height="s32"
      width="s32"
      alignItems="center"
      justifyContent="center"
      borderRadius={{ all: 'abs012' }}
    >
      <Icon.Medium icon="alert-circle" color="champagne1000" />
    </Box>
  )

  const divWithAvatar = (
    <Box
      className={styles.employeeMarker}
      alignItems="center"
      justifyContent="spaceBetween"
      flexDirection="row"
    >
      <Box justifyContent="flexStart">{isIncident ? alertIcon : avatar}</Box>
      <Box justifyContent="flexEnd">
        <h2 className={styles.label}>{label}</h2>
      </Box>
      <Box className={styles.pinWithAvatar}>
        <img src={markerPointer} />
      </Box>
    </Box>
  )

  const divWithoutAvatar = (
    <Box
      className={styles.workplaceMarker}
      alignItems="center"
      justifyContent="center"
      flexDirection="row"
    >
      <Box justifyContent="center" alignItems="center">
        <h2 className={styles.label}>{label}</h2>
      </Box>
      <Box className={styles.pinWithoutAvatar}>
        <img src={markerPointer} />
      </Box>
    </Box>
  )

  const div = avatar ? divWithAvatar : divWithoutAvatar
  const content = document.createElement('div')
  content.innerHTML = renderToStaticMarkup(div)
  return content
}

export default CustomMarkerDiv
